// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store  from './store.js'
import BootstrapVue from 'bootstrap-vue'

import './assets/css/main.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css';
import Vuelidate from "vuelidate";
import i18n from './i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import esLocale from 'element-ui/lib/locale/lang/es'
import VueNumberInput from '@chenfengyuan/vue-number-input';
import VModal from 'vue-js-modal'

// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'
import { MdButton, MdIcon, MdSwitch, MdChips, MdProgress  } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'


import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
const moment = require('vue-moment');
moment.suppressDeprecationWarnings = true;

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);


import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)


const options = {
    toast: {
      position: SnotifyPosition.centerTop
    }
  }
const fb = require('./firebaseConfig.js')

Vue.config.productionTip = true
// Vue.config.devtools = true;

Vue.use(BootstrapVue);
Vue.component('icon', Icon)
Vue.use(Snotify, options)
Vue.use(Vuelidate);
Vue.use(ElementUI, { locale })
Vue.component(VueNumberInput.name, VueNumberInput);
Vue.use(moment);
Vue.use(VModal)
// Vue.use(VueMaterial)
Vue.use(MdButton)
Vue.use(MdIcon)
Vue.use(MdChips)
Vue.use(MdSwitch)
Vue.use(MdProgress)
let app;

fb.auth.onAuthStateChanged(user => {
  if (!app) {
      app = new Vue({
        el: '#app',
        router,
        store,
        i18n,
        render: h => h(App)
      })
  }
})





// WEBPACK FOOTER //
// ./src/main.js